import React, {useEffect} from 'react';
import {ScrollView, StyleSheet, Text} from 'react-native';
import {getObject} from '../services/storage-service';
import MovieTile from '../components/movie-tile';
import {getMovie} from '../services/movie-service';

class MyMovies extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      myMovies: [<Text key="no-movies">No movies in your list</Text>],
    }
    console.log("constructor");
    this.loadMovies();
  }

  loadMovies() {
    getObject('favoriteMovies').then((favoriteMovies) => {
      getObject('watchedMovies').then((watchedMovies) => {
        console.log("load movies");
        if(favoriteMovies === null) {
          favoriteMovies = [];
        }
        // merge the two lists
        let movies = favoriteMovies.concat(watchedMovies);
        // remove duplicates
        movies = movies.filter((movie, index) => {
          return movies.indexOf(movie) === index;
        });
        if(movies.length === 0) {
            this.setState({myMovies: [<Text key="no-movies">No movies in your list</Text>]});
          return;
        }
        // get movies and create tiles
        let movieTiles = movies.map((movieId) => {
          return getMovie(movieId).then((movie) => {
            return (
                <MovieTile
                    movie={movie}
                    key={movie.id}
                    updateFunction={this.loadMovies.bind(this)}
                />
            );
          });
        });
        // set state
        Promise.all(movieTiles).then((movieTiles) => {
          this.setState({myMovies: movieTiles});
        });
      });
    });
  }

  render() {
    console.log("render");
    return (
        <ScrollView contentContainerStyle={styles.container}>
          {this.state.myMovies}
        </ScrollView>
    );
  }

  componentDidMount() {
    console.log("componentDidMount");
    this.loadMovies();
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'top',
  }
});

export default MyMovies;
